import { render, staticRenderFns } from "./ProductIndicatorComponent.vue?vue&type=template&id=6e5a50cc&scoped=true"
import script from "./ProductIndicatorComponent.vue?vue&type=script&lang=js"
export * from "./ProductIndicatorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5a50cc",
  null
  
)

export default component.exports